import styled, { css } from 'styled-components';
import colors from 'Styles/colors';
import { disableTextSelection } from 'Styles/effects/text';
import { ReactComponent as FRound } from 'Images/f_round.svg';

export const Wrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  background-color: ${({ theme }) => theme.backgrounds.memoListItem};
  text-align: left;
  ${disableTextSelection}
  border-radius: 3px;
  box-shadow: 0 2px 15px 0 ${({ theme }) => theme.shadows.agentsCard};
  ${({ selected, theme }) => selected === true && `
    border: 1px solid ${theme.borders.workspaceSelectedItem};
  `}
`;
Wrapper.displayName = 'Wrapper';

export const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1 1 0px;
  overflow: hidden;
  margin-left: 20px;
`;
TextWrapper.displayName = 'TextWrapper';

export const TitleWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
`;
Wrapper.displayName = 'Wrapper';

export const Title = styled.div`
  font-size: 17px;
  font-weight: 600;
  color: ${({ theme }) => theme.text.memoListItemTitle};
  width: calc(93% - 75px);
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  margin-left: 12px;
`;
Title.displayName = 'Title';

export const Status = styled.div`
flex: 0 0 auto;
width: ${(props) => props.width || '69px'};
max-width: ${(props) => props.width || '69px'};
margin-left: ${(props) => (props.noMargin ? '0' : '25px')};
margin-right: ${(props) => (props.noMargin ? '0' : '20px')};
  border-radius: 10px;
  font-size: 12.5px;
  font-weight: bold;
  line-height: 25px;
  text-align: center;
  height: 25px;
  color: ${colors.white};
  ${(props) => (props.value === 'offline'
    ? css`background: ${colors.blueGrey};`
    : css`background: ${colors.blueCerulean};`)
}
`;
Status.displayName = 'Status';

export const FaradayLogo = styled(FRound)``;
FaradayLogo.displayName = 'FaradayLogo';

export const Header = styled.div`
  display: flex;
`;
Header.displayName = 'Header';

export const TopWrapper = styled.div`
  background-color: ${({ theme }) => theme.backgrounds.sidebarSubMenu};
  display: flex;
  flex-direction: column;
  padding: 28px 30px 17px 28px;
`;
TopWrapper.displayName = 'TopWrapper';

export const BottomWrapper = styled.div`
  background-color: ${({ theme }) => theme.backgrounds.agentsCardBottomWrapper};
  padding: 0 30px 28px 28px;
  display: flex;
  flex-direction: column;
  border: 1px solid ${({ theme }) => theme.borders.agentsBottom};
`;
BottomWrapper.displayName = 'BottomWrapper';

export const CustomStatus = styled(Status)`
  font-size: 10px;
  font-weight: 500;
  width: 49px;
  height: 20px;
  line-height: 2;
  margin: 0 0 0 auto;
  border-radius: 6px;
`;
CustomStatus.displayName = 'CustomStatus';

export const DescriptionLabel = styled.div`
  font-size: 11.5px;
  font-weight: 600;
  color: ${({ theme }) => theme.text.workspaceItem};
`;
DescriptionLabel.displayName = 'DescriptionLabel';

export const DescriptionContent = styled.div`
  font-size: 11.5px;
  color: ${({ theme }) => theme.text.workspaceItem};
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;  
  overflow: hidden;
`;
DescriptionContent.displayName = 'DescriptionContent';
